import { IconButton, Stack, Typography } from '@mui/material'
import { com } from '@eidu/form'
import React from 'react'
import { AddCircleOutlined } from '@mui/icons-material'
import PermissionsInput, { PermissionWithId } from '../input/PermissionsInput'
import SelectorEditor from '../input/SelectorEditor'
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import EntitySelector = com.eidu.sharedlib.entity.selector.EntitySelector
import EntityTypeKind = com.eidu.sharedlib.entity.type.EntityTypeKind
import GlobalAction = com.eidu.sharedlib.entity.permission.GlobalAction
import GlobalPermission = com.eidu.sharedlib.entity.permission.GlobalPermission

type PermissionGrantFormProps = {
  entityTypes: readonly EntityType[]
  userSelector: EntitySelector
  setUserSelector: (selector: EntitySelector) => void
  selectedPermissions: readonly PermissionWithId[]
  setSelectedPermissions: (permissions: readonly PermissionWithId[]) => void
}

const PermissionGrantForm = ({
  entityTypes,
  userSelector,
  setUserSelector,
  selectedPermissions,
  setSelectedPermissions,
}: PermissionGrantFormProps) => (
  <Stack padding={0} spacing={3} sx={{ width: '100%', overflowX: 'auto' }}>
    <Typography variant="h5">Users</Typography>
    <SelectorEditor
      selector={userSelector}
      onChange={setUserSelector}
      entityTypes={entityTypes.filter((type) => type.kind.equals(EntityTypeKind.User))}
      selectorType="target"
    />
    <Stack direction="row" spacing={2} alignItems="center">
      <Typography variant="h5">Actions</Typography>
      <IconButton
        onClick={() =>
          setSelectedPermissions(
            selectedPermissions.toSpliced(0, 0, {
              id: crypto.randomUUID(),
              permission: new GlobalPermission(GlobalAction.values()[0]),
            })
          )
        }
      >
        <AddCircleOutlined color="primary" />
      </IconButton>
    </Stack>
    <PermissionsInput
      userSelector={userSelector}
      entityTypes={entityTypes}
      selected={selectedPermissions}
      onSelectedChange={setSelectedPermissions}
    />
  </Stack>
)

export default PermissionGrantForm
